/**
 * @desc 扫描托盘号获取托盘信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inPlateMaster.postInPlateScanPlate.Params, options?: any) {
  return updateResponse(
    http(URL + `/inPlate/scanPlate`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
